import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  hasInfluencerFeature,
  isPaidInfluencerPlan,
} from '../config/influencerFeatureAccess.config';
import {
  selectHasInfluencerSubscription,
  selectInfluencerPlanType,
} from '../../../Redux/userSlice';

export function useInfluencerFeatureAccess(featureKey) {
  const planType = useSelector(selectInfluencerPlanType);
  const hasSubscription = useSelector(selectHasInfluencerSubscription);

  const allowed = useMemo(
    () => hasInfluencerFeature(planType, featureKey),
    [planType, featureKey]
  );

  return {
    planType,
    hasSubscription,
    allowed,
    isPaidPlan: isPaidInfluencerPlan(planType),
  };
}
